import {JsonObject, JsonProperty} from 'json2typescript';
import RconMessageLogDto from "@/logic/ark-stats-backend/dto/rconmessagelog/RconMessageLogDto";

@JsonObject('RconMessageLogListDto')
export default class RconMessageLogListDto {
    @JsonProperty('data', [RconMessageLogDto])
    data: RconMessageLogDto[] = [];
}
